import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appNumericOnly]'
})
export class NumericOnlyDirective {
  private regex: RegExp = new RegExp(/^\d*\.?\d*$/);


  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;

    // Allow only digits and at most one decimal point
    if (!this.regex.test(inputValue)) {
      // Replace invalid characters or characters that exceed decimal point constraints
      const validValue = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      this.renderer.setProperty(this.el.nativeElement, 'value', validValue);
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = parseFloat(input.value).toString();
    this.renderer.setProperty(this.el.nativeElement, 'value', value);
  }

}
